(() => {
  const eventNames = {
    report_view: 'kopero_report_view',
    article_to_product: 'kopero_article_to_product',
    article_to_collection: 'kopero_article_to_collection',
  };

  const reportHandles = new Set([
    'testdossier',
    'pruefdossier',
    'test-dossier',
    'dossier-d-essais',
    'expediente-de-ensayos',
    'dossie-de-ensaios',
    'testrapporter',
    'testdokumentation',
  ]);

  const send = (eventName, params) => {
    const publish = window.Shopify?.analytics?.publish;

    if (typeof publish === 'function') {
      Promise.resolve(publish(eventName, params)).catch(() => {});
    } else if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...params });
    }

    document.dispatchEvent(
      new CustomEvent(`kopero:${eventName}`, { detail: params }),
    );
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const destination = new URL(link.href, window.location.href);
    const destinationParts = destination.pathname.split('/').filter(Boolean);
    const destinationHandle = destinationParts.at(-1);
    const isArticle = window.location.pathname.includes('/blogs/');
    let track = link.dataset.keTrack;

    if (!track && reportHandles.has(destinationHandle)) {
      track = 'report_view';
    } else if (!track && isArticle && destination.pathname.includes('/products/')) {
      track = 'article_to_product';
    } else if (!track && isArticle && destination.pathname.includes('/collections/')) {
      track = 'article_to_collection';
    }

    const eventName = eventNames[track];
    if (!eventName) return;

    const container = link.closest('[id], header, footer, main');

    send(eventName, {
      link_url: link.href,
      link_text: link.textContent.trim().replace(/\s+/g, ' ').slice(0, 200),
      link_location:
        link.dataset.keLocation || container?.id || container?.tagName.toLowerCase() || '',
      target_title: link.dataset.keTargetTitle || '',
      product_id: link.dataset.keProductId || '',
      page_path: window.location.pathname,
      page_language: document.documentElement.lang || '',
    });
  });
})();
